import store from '@/store';
import { FEATURE_FLAGS } from '@/constants';

export async function featureFlagMiddleware(to, _, next) {
  // Получаем флаг редизайна из Vuex
  const isNewDesign = store.getters['featureFlags/isNewDesign'];
  to.isNewDesign = isNewDesign;

  // Если флаг включён/выключён, пройдём по всей цепочке matched.
  // Для каждой записи с meta.newComponent подменяем components.default,
  // кэшируя оригинальный компонент для корректного возврата при выключении флага.
  const recordsWithNewComponent = to.matched.filter((r) => r?.meta?.newComponent);
  for (const record of recordsWithNewComponent) {
    // Инициализация хранилища оригинального компонента
    if (!record.meta._originalComponent) {
      // У некоторых записей component хранится в components.default
      const original = record.components?.default || record.component;
      record.meta._originalComponent = original;
    }

    // Гарантируем наличие объекта components
    record.components = record.components || {};

    // Подмена компонента в зависимости от флага
    record.components.default = isNewDesign ? record.meta.newComponent : record.meta._originalComponent;
  }

  return next();
}
